<template>
  <v-app>
    <Loading v-if="isLoading"></Loading>
    <router-view />
    <SnackBar/>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import SnackBar from '@/components/SnackBar';
export default {
  name: "App",
  components: {
    SnackBar
  },
  computed: {
    ...mapState({
      isLoading: state => state.toggle.isLoading
    })
  }
};
</script>
